/**
 * Block Illegal invocations errors triggered by Facebook bots. Facebook bots
 * do not present themselves in user-agents so we've to manually check for
 * the specific error and a fbclid parameter in the URL.
 * Source: https://github.com/aFarkas/lazysizes/issues/520
 *
 * @param {Object} exception
 * @returns {boolean} False will discard the event, true will keep it.
 */
const illegalInvocationFilter = (exception) => {
  if (typeof window === 'undefined' || typeof window.location === 'undefined') {
    return true;
  }

  const hasFbclid = window.location.href.indexOf('fbclid=') >= 0;

  // This error should only be ignored when fbclid exists in the URL.
  if (!hasFbclid) {
    return true;
  }

  return (
    exception.type !== 'TypeError'
    || exception.value.indexOf('Illegal invocation') < 0
  );
};

export default illegalInvocationFilter;
